import { withInstall } from '@zoryn/utils'
import FormDesigner from './src/form-designer.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZFormDesigner: SFCWithInstall<typeof FormDesigner> =
  withInstall(FormDesigner)
export default ZFormDesigner

export * from './src/form-designer'

export type FormDesignerInstance = InstanceType<typeof FormDesigner> & unknown
